<template>
    <div class="login">
        <div class="page">
            <div class="row">
                <div class="col image">
                    <img src="../../assets/images/icon.png">
                </div>
            </div>
            <div class="row">
                <div class="col title">
                    <h1>Willkommen bei iGroove.</h1>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <form>
                        <label for="username">Email:</label><br>
                        <input type="text" :value="email"><br>
                        <input type="password" class="" :placeholder="password_hint">

                        <router-link :to="{name: 'reset',params: { email }}" activeClass="active" tag="a"
                                     :email="email"><a>Passwort vergessen?</a></router-link>
                        <br>
                        <router-link :to="{name: 'neue_beteiligung'}" tag="button">Anmelden</router-link>
                        <button id="acount">Account beantragen</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Header from '../Header';

    export default {
        name: 'app',
        data() {
            return {
                msg: 'Welcome to Your Vue.js App',
                email: 'max@mustermann.ch',
                password_hint: 'Passwort'
            }
        },
        components: {
            appHeader: Header
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/css/style';
    .login {
        width: 100%;
        height: 100vh;
        background-image: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.9)), url("../../assets/images/login_background.png");
        background-size: cover;
        background-position: center;
        color: $betuszin;

        .page {
            width: 90%;
            margin: auto;
            .image {
                margin-top: 70px;
                margin-left: 20px;
            }
            .title {
                margin: 50px 0px 35px 20px;

                h1 {
                    font-size: 3.2rem;
                    font-weight: 700;
                    font-style: normal;
                    font-stretch: normal;
                    line-height: 36px;
                }
            }

            form {
                width: 88%;
                margin: auto;
                label {
                    font-size: 1.2rem;
                    text-transform: uppercase;
                    font-weight: 400;
                    font-family: 'SF Text';
                    margin-bottom: 0px;
                }
                input {
                    width: 100%;
                    background: transparent;
                    border: none;
                    border-bottom: 1px $betuszin solid;
                    color: $betuszin;
                    font-size: 1.7rem;
                    padding: 5px 0;
                    &:last-of-type {
                        margin-top: 23px;
                    }
                    &::placeholder {
                        color: $betuszin;
                    }
                }

                a {
                    display: block;
                    text-align: right;
                    font-size: 1.1rem;
                    color: inherit;
                    padding: 4px 0;
                }
                button {
                    color: $betuszin;
                    font-size:1.5rem;
                    display: block;
                    margin: 35px auto 20px auto;
                    width: 100%;
                    display: block;
                    background-color: $lila;
                    padding: 13px 0;
                    border-radius: 5px;
                    border: none;
                }
                #acount{
                    background-color: transparent;
                    margin-top:37px;
                }
            }


        }
    }


</style>



// WEBPACK FOOTER //
// src/components/login/Login.vue